import React, { useEffect, useState } from "react";
import { connect } from "react-redux";

import { login } from "../../store/actions";
import { AUTH_CONFIG, REACT_APP_COLBI_THEME } from "../../environmentVariables";

import { useAuth } from "react-oidc-context";
import { getUser, handleOAuthCallback, sendOAuthRequest } from "../../services/AuthSamlService";
import LoadingPage from "./LoadingPage";
import { Redirect } from "react-router-dom/cjs/react-router-dom.min";
import { decodeUserSession } from "../../utils/utils";
import { getLocale } from "../../utils/locale";

const SAMLCallback = (props) => {
    const { login, location, match, user } = props;

    const userInformation = decodeUserSession(user);

    const [loginAttempt, setAttempt] = useState(false);

    const [appTheme] = useState(
        REACT_APP_COLBI_THEME
            ? REACT_APP_COLBI_THEME.toLocaleLowerCase()
            : document.localStorage.getItem("theme")
              ? document.localStorage.getItem("theme")
              : "sovos",
    );

    const auth = useAuth();

    const locale = getLocale(auth, match);

    useEffect(() => {
        window.localStorage.setItem("login-mode", "saml");
    }, []);

    useEffect(() => {
        const root = document.getElementsByTagName("html")[0];
        root.setAttribute("class", appTheme);
    }, [appTheme]);

    useEffect(() => {
        if (!auth?.error && !location?.search.includes("state") && !loginAttempt) {
            window.localStorage.setItem("request-sent", "true");
            sendOAuthRequest();
        }
    }, [location, auth, loginAttempt]);

    useEffect(() => {
        if (!auth?.error && !loginAttempt && !auth?.isLoading && auth.isAuthenticated) {
            getUser().then(({ profile, id_token }) => {
                const { email } = profile;
                login(
                    email.toLowerCase(),
                    id_token,
                    "SAML",
                    {
                        setAttempt: setAttempt,
                    },
                    null,
                    AUTH_CONFIG["saml"].jwks_uri,
                    locale,
                );
            });
            return;
        }
        if (
            !auth?.error &&
            !auth?.isLoading &&
            !auth?.isAuthenticated &&
            window.localStorage.getItem("request-sent") === "true" &&
            !loginAttempt
        ) {
            handleOAuthCallback().catch((err) => {
                console.error(err);
            });
        }
    }, [auth, login, loginAttempt, locale]);

    if (!auth?.isLoading && auth?.error) {
        console.error(auth.error);
        return <Redirect to={`/${locale}/unauthorized`} />;
    }

    if (loginAttempt && !auth.isLoading && auth.isAuthenticated && !userInformation) {
        return <Redirect to={`/${locale}/forbidden`} />;
    }

    if (!auth?.isLoading && auth.isAuthenticated && loginAttempt && userInformation) {
        window.localStorage.removeItem("request-sent");
        return <Redirect to={`/${locale}`} />;
    }

    return <LoadingPage />;
};

export default connect(({ user }) => ({ user }), { login })(SAMLCallback);
